import React, { useEffect } from 'react'
import useNavigation from '../Utils/navigationUtils'

const HomePage = _ => {
  const { navigateToHome } = useNavigation()

  useEffect(() => {
    navigateToHome()
  }, [navigateToHome])

  return (
    <>
    </>
  )
}

export default HomePage
